<template lang="pug">
  Default
    CommonSection(title="Добро пожаловать в мир TeRoom!")
      FormBlock.b-news-detail
        ._created-at 18.01.2024 в 12:00
        ._title
          img(src="/img/teroom-avatar.png")
          |Команда Teroom
        BaseText._text
          p Мы знаем, что освоение нового продукта может быть настоящим вызовом.
          p Но не волнуйтесь!
          p Наша команда стремится сделать ваше взаимодействие с TeRoom максимально легким и приятным.
          p Мы собрали для вас все ключевые ресурсы, чтобы вы могли сосредоточиться на главном — вашем успехе!
          br
          p
            b 1. 📚 Гайды по платформе.
          p Погрузитесь в наш обширный каталог <a href="/guides">гайдов</a> и откройте для себя все возможности TeRoom! Станьте мастером платформы!
          br
          p
            b 2. 💬 Онлайн чат поддержки.
          p У вас возник вопрос? Не стесняйтесь обращаться к нам через <a href="/personal/notifications">чат поддержки</a>! Мы всегда на связи, чтобы помочь вам (и, если нужно, вы можете отключить его в настройках).
          br
          p
            b 3. 🤝 Индивидуальная консультация и обучение.
          p Хотите получить персонализированную помощь? Напишите нам в <a target="_blank" href="https://t.me/i_teroom">Telegram</a>, и мы с радостью организуем консультацию для вас!
          br
          p
            b 4. 🛠️ Техническая поддержка.
          p Если у вас есть технические вопросы, не медлите! Напишите на <a target="_blank" href="mailto:support@teroom.ru">support@teroom.ru</a> — мы готовы помочь вам 24/7!
          br
          p
            b 5. 🎓 Полезные вебинары и советы.
          p Не упустите шанс учиться у лучших! Подписывайтесь на наш <a href="https://t.me/teroomru" target="_blank">Telegram-канал</a> и участвуйте в наших увлекательных вебинарах и практикумах, чтобы максимально эффективно использовать TeRoom!
          p Мы здесь, чтобы поддержать вас на каждом шагу вашего пути к успеху!✨
        img(src="/img/news-stub2.png?q=2")
</template>

<script>
import Default from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import BaseText from '@/components/BaseText.vue';
import FormBlock from '@/components/FormBlock.vue';

export default {
  name: 'NewsList',
  components: {
    FormBlock,
    BaseText,
    CommonSection,
    Default,
  },
};
</script>

<style scoped lang="scss">
  .news-detail {
    width: 946px;
    max-width: 100%;

    &__created-at {
      font-size: 11px;
      line-height: 14px;
      letter-spacing: 0.02em;
      color: #788CA1;
      margin-bottom: 12px;
    }

    &__title {font-weight: 500;
      display: flex;
      align-items: center;
      gap: 10px;
      letter-spacing: 0.01em;
      font-size: 14px;
      line-height: 18px;
      color: #1E3147;
      margin-bottom: 20px;

      img {
        margin-top: 4px;
      }
    }

    &__text {
      margin-bottom: 38px;
    }
  }

  b {
    font-weight: bold;
  }
</style>
